import { Icons } from 'components/Icon';
import { INav, IUserNav } from 'types/INav.type';
import { STEPS } from './steps';

export const navs: INav[] = [
  {
    name: 'About',
    path: '/about'
  },
  {
    name: 'How it Works',
    path: '/how-it-works'
  },
  {
    name: 'Will Stories',
    path: '/will-stories'
  }
];

export const userNavs: IUserNav[] = [
  {
    name: 'Dashboard',
    path: '/dashboard',
    main: 'dashboard',
    icon: Icons.Dashboard,
    pageId: null
  },
  {
    name: 'Assets',
    path: '/dashboard/assets',
    main: 'assets',
    icon: Icons.Assets,
    pageId: null
  },
  {
    name: 'Beneficiary',
    path: '/dashboard/beneficiary',
    main: 'beneficiary',
    icon: Icons.Beneficiary,
    pageId: STEPS.BENEFICIARY_INFORMATION
  },
  {
    name: 'Spouse & Children',
    path: '/dashboard/spouse-children',
    main: 'spouse-children',
    icon: Icons.Users,
    pageId: STEPS.SPOUSE_INFORMATION
  },
  {
    name: 'Executors',
    path: '/dashboard/executors',
    main: 'executors',
    icon: Icons.Executors,
    pageId: STEPS.EXECUTOR_INFORMATION
  },
  {
    name: 'Guardians',
    path: '/dashboard/guardians',
    main: 'guardians',
    icon: Icons.Guardians,
    pageId: STEPS.GUARDIAN_INFORMATION
  },
  {
    name: 'Trustees',
    path: '/dashboard/trustee',
    main: 'trustee',
    icon: Icons.Trustees,
    pageId: STEPS.TRUSTEE_INFORMATION
  }
  // {
  //   name: 'Message',
  //   path: '/dashboard/message',
  //   main: 'message',
  //   icon: Icons.Message
  // }
];

export const adminNavs: IUserNav[] = [
  {
    name: 'Dashboard',
    path: '/admin',
    main: 'admin',
    icon: Icons.Dashboard
  },
  {
    name: 'Prospects',
    path: '/admin/prospects',
    main: 'prospects',
    icon: Icons.SingleUser
  },
  {
    name: 'Customers',
    path: '/admin/customers',
    main: 'customers',
    icon: Icons.MultipleUser
  },
  {
    name: 'Staff',
    path: '/admin/staff',
    main: 'staff',
    icon: Icons.TwoUsers
  }
  // {
  //   name: 'Message',
  //   path: '/admin/message',
  //   main: 'message',
  //   icon: Icons.Message
  // },
  // {
  //   name: 'Contact Lawyer',
  //   path: '/admin/call',
  //   main: 'call',
  //   icon: Icons.Call
  // }
];

export const paidPages = [
  {
    name: 'Trustee',
    path: '/dashboard/assets/trustee/manage-trustee',
    pageId: STEPS.TRUSTEE_INFORMATION
  }
];
